import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import cx from 'classnames';
import tw from 'twin.macro';
import styled from 'styled-components';

// A div, not a p: this renders Sitecore rich text via dangerouslySetInnerHTML,
// which carries block content (the `& ul` rule below exists precisely because
// authors put lists in these fields). A <p> may not contain <p>/<ul>, so the
// browser would hoist them out and hydration would mismatch (React #418).
const StyledP = styled.div`
  ${({ shadowed }) => shadowed && 'text-shadow: 0 3px 10px rgba(0, 0, 0 );'}
  ${({ newSchemaColor, color }) => newSchemaColor && `color: ${color};`}
  & ul {
    ${tw`list-disc`}
    padding-left: 1.125rem;
  }
`;

const Copy = ({
  children,
  className,
  shadowed = false,
  color = 'blue',
  ...rest
}) => (
  <StyledP
    tabindex='-1'
    {...rest}
    className={cx(
      'text-normal mb-10-mattamy font-graphie',
      {
        'text-white': color === 'white',
        'text-mattamy-blue': color === 'blue',
        'text-black': color === 'black',
        'text-mattamy-search-gray': color === 'gray',
        'text-mattamy-gray-font': color === 'grayonwhite',
      },
      className,
    )}
    shadowed={shadowed}
    newSchemaColor={color.includes('#')}
    color={color}
  >
    <RichText
      tabIndex='-1'
      tag='span'
      className='richtext'
      field={{ value: children }}
    />
  </StyledP>
);

Copy.propTypes = {
  color: PropTypes.oneOf(['white', 'blue']),
  className: PropTypes.string,
};

export default Copy;
